import api from './api';

export default class EnderecoService {
    constructor() {
        throw 'Não é possível instanciar EnderecoService';
    }

    static async listaEstados() {
        const endpoint = mergeEndpoint() + "estados";
        return await api.get(endpoint);
    }

    static async listaMunicipios(siglaEstado) {
        const  endpoint = mergeEndpoint() + `municipios/${siglaEstado}`
        return await api.get(endpoint);
    }
}

const mergeEndpoint = id => {
    return `api-endereco/${id || ''}`;
};


// WEBPACK FOOTER //
// ./src/services/enderecoService.js